import { Information } from '@components/Information';
import { Stack, Typography } from '@mui/material';
import { theme } from '@src/theme';
import { DiagnosesInput } from './DiagnosesInput';
import { useFormContext } from 'react-hook-form';
import { Tag } from '@components/Tag';
import { memo } from 'react';

export const Diagnoses = memo(() => {
  const { watch, setValue } = useFormContext();
  const [diagnosisIds] = watch(['diagnosisIds']);

  const onDeleteDiagnosis = (id: string) => {
    const newAdditioanlTests = diagnosisIds.filter(({ id: diagnosisId }) => id !== diagnosisId);
    setValue('diagnosisIds', newAdditioanlTests);
  };

  return (
    <Stack sx={{ backgroundColor: theme.palette.grey['200'] }} gap="12px" padding="12px 18px">
      <Typography color="grey.700" variant="body16Bold" lineHeight="24px">
        Diagnoses
      </Typography>
      <Information description="When creating order drafts, the appropriate diagnosis will be assigned individually for each order based on the patient's diagnosis." />
      <DiagnosesInput />
      {diagnosisIds.map(diagnosis => (
        <Tag
          contentText={diagnosis.description}
          startContent={
            <Typography
              color="secondary.main"
              fontSize="14px"
              fontWeight={600}
              lineHeight="18px"
              mr="12px"
              flexShrink={0}
            >
              {diagnosis.name}
            </Typography>
          }
          value={diagnosis.id}
          onDelete={onDeleteDiagnosis}
        />
      ))}
    </Stack>
  );
});
